import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery } from '../styles';
import { Link } from './ui';
import logo from '../images/logo.svg';

const StyledLogo = styled(Link)`
  display: inline-block;
`;

const StyledImage = styled.img`
  width: 120px;

  ${minBreakpointQuery.tiny`
    width: 150px;
  `}

  ${minBreakpointQuery.small`
    width: 180px;
  `}

  ${minBreakpointQuery.large`
    width: 210px;
  `}

  ${minBreakpointQuery.xxlarge`
    width: 240px;
  `}
`;

const Logo = ({ ...props }) => (
  <StyledLogo to="/" {...props}>
    <StyledImage src={logo} alt="Ecotalk logo" />
  </StyledLogo>
);

export default Logo;
